import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {},
        content: {
            layerStyle: 'full-width',
            m: 'auto',
            textAlign: 'center',
            py: {base: 'small.base', sm: 'small.sm', md: 'medium.md', lg: 'medium.lg'},
            px: {base: 'small.base', sm: 'medium.sm', md: 'small.md', lg: '0'},
            gap: {base: remCalc(16), md: remCalc(24)},
        },
        title: {
            textStyle: 'head-large',
            fontWeight: 'medium',
        },
        description: {
            textStyle: 'body-large',
        },
    },
    variants: {
        black: {
            container: {
                backgroundColor: 'background.dark',
                color: 'text.inverse',
            },
        },
        grey: {
            container: {
                backgroundColor: 'background.light',
            },
        },
    },
}
